import React, { useState, useEffect } from 'react';
import { Box, Button, Typography, Alert, TextField } from '@mui/material';

import { api } from 'src/Api';
import PropertyStatusDropdown from './PropertyStatusDropdown';
import { LoadingButton } from '@mui/lab';
import Label from 'src/components/Label';

export default function ChangeJobStatus({ handleClose, property, refreshAdmin }) {
  const [statusLoading, setStatusLoading] = useState(false);
  const [selectedStatus, setselectedStatus] = useState(null);
  const [reason, setreason] = useState('');
  const [showAlert, setshowAlert] = useState(false);

  function AssignStatus(statusSelected, productId) {
    setStatusLoading(true);
    const myHeaders = new Headers();
    const token = localStorage.getItem('token');
    myHeaders.append('Authorization', `Bearer ${token}`);

    const formdata = new FormData();
    formdata.append('id', productId);
    formdata.append('status', statusSelected?.id);
    const requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: formdata,
      redirect: 'follow'
    };

    fetch(api.update_job_status, requestOptions)
      .then((response) => {
        if (response.status === 201 || response.status === 200) {
          return response.json();
        } else {
          throw new Error(`Failed to update status: ${response.status} ${response.statusText}`);
        }
      })
      .then((result) => {
        refreshAdmin();
      })
      .catch((error) => console.error('Error updating status:', error))
      .finally(() => {
        setStatusLoading(false);
      });
  }

  useEffect(() => {
    setshowAlert(false);
    setreason('');
  }, [selectedStatus]);

  const getStatusColor = (status) => {
    switch (status?.toLowerCase()) {
      case 'active':
        return 'success';
      case 'deleted':
        return 'error';
      case 'pending':
        return 'info';
      case 'hired':
        return 'warning';
      case 'paused':
        return 'default';
      default:
        return 'primary';
    }
  };

  return (
    <Box p={3} flexDirection={'column'} display={'flex'} flex={1}>
      <Typography pb={5} align="center" variant="h5">
        Change Job Status
      </Typography>
      <Typography
        variant="h5"
        style={{
          fontWeight: 'bold',
          marginBottom: 20,
          display: 'flex',
          alignItems: 'center'
        }}
      >
        <span>Current Status:</span>
        <Label
          style={{ height: 30, width: 100 }}
          variant="ghost"
          color={getStatusColor(property?.status)}
        >
          <div
            style={{
              // marginLeft: 8,
              padding: '4px 10px',
              borderRadius: 4,
              fontWeight: 'bold',
              textTransform: 'capitalize'
            }}
          >
            {property?.status || 'N/A'}
          </div>
        </Label>
      </Typography>

      <PropertyStatusDropdown
        alreadyRole={property?.status}
        fullWidth={true}
        setRole={(statusSelected) => {
          setselectedStatus(statusSelected);
        }}
      />
      {/* {selectedStatus?.toLowerCase() === 'declined' && (
        <>
          <TextField
            style={{ width: '100%', marginTop: 10 }}
            id="outlined-multiline-static"
            label="Reason"
            multiline
            rows={4}
            value={reason}
            onChange={(e) => {
              if (showAlert) {
                setshowAlert(false);
              }
              setreason(e.target.value);
            }}
          />

          {reason === '' && showAlert && (
            <Alert severity="error" style={{ marginTop: 10 }}>
              Please provide a reason for declining.
            </Alert>
          )}
        </>
      )} */}
      <Box display={'flex'} flexDirection={'row'} justifyContent={'flex-end'} mt={2}>
        <LoadingButton
          disabled={!selectedStatus}
          style={{ marginTop: 10, marginRight: 10 }}
          onClick={() => {
            if (selectedStatus?.name?.toLowerCase() === 'declined' && reason == '') {
              setshowAlert(true);
            } else {
              AssignStatus(selectedStatus, property?.id);
            }
          }}
          variant="contained"
          loading={statusLoading}
        >
          Save
        </LoadingButton>
        <Button style={{ marginTop: 10 }} color="primary" variant="outlined" onClick={handleClose}>
          Close
        </Button>
      </Box>
    </Box>
  );
}
